import React, { Component } from "react";
import $ from "jquery";
import CermonyBanner from "../../MyFiles/Slide/CermonyLamerd.jpg";
import CermonyLamerd from "../../MyFiles/CermonyPoster.jpg";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

class Cermony extends Component {
  state = {
    userQuranTypeJson: [],
    userCompetitionRequestJson: [],
    calenderMessage: "",
    calenderSelect: 0,
    countRelationMessage: "",
    errorMessage: "",
    stepNo: 1,
    isRegister: true,
    isSubmitForceRegister: false,
  };
  componentDidMount() {
    this.getRequest();
  }
  toggleSubmitForceRegister = () => {
    this.setState({ isSubmitForceRegister: !this.state.isSubmitForceRegister });
  };
  toggleRegister = () => {
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleEdit = () => {
    this.props.getAllUserRelation();
    this.setState({ stepNo: 2 });
    this.setState({ isRegister: !this.state.isRegister });
  };
  toggleSubmit = () => {
    if (this.state.stepNo === 1) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 2 });
    }
    if (this.state.stepNo === 2) {
      this.props.getAllUserRelation();
      this.setState({ stepNo: 3 });
    }
    if (this.state.stepNo === 3) {
      if (
        this.state.calenderMessage === null ||
        this.state.calenderMessage === ""
      ) {
        var errorMessage =
          "روز مراسمی که میخواهید در آن شرکت کنید را انتخاب کنید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        var length = document.getElementsByClassName("dvCandidate active")
          .length;
        var message =
          "درخواست شما برای روز " +
          this.state.calenderMessage +
          " با " +
          length +
          " همراه و در مجموع " +
          (length + 1) +
          " نفر در سیستم ثبت خواهد شد، آیا مطمئن هستید؟";

        this.setState({ confirmMessage: message });
        this.toggleSubmitForceRegister();
      }
    }
  };
  toggledecline = () => {
    if (this.state.stepNo === 1) {
      this.setState({ isRegister: !this.state.isRegister });
    }
    if (this.state.stepNo === 2) {
      this.setState({ stepNo: 1 });
    }
    if (this.state.stepNo === 3) {
      this.setState({ stepNo: 2 });
    }
  };
  selectCalender = (id, e) => {
    if (id !== null && id !== this.state.calenderSelectID) {
      this.setState({ calenderSelectID: id });
      var cusid_ele = document.getElementsByClassName("dvCalender");
      var calenderText = document.getElementById("Calender_" + id).innerText;
      this.setState({ calenderMessage: calenderText });
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var getValue = $(item).attr("data-target");
        if (getValue.includes(id)) {
          this.setState({ calenderSelect: id });
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      }
    }
  };
  submitForm = () => {
    this.toggleSubmitForceRegister();
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
      var SendRequest = false;
      var selectRelationID = 0;
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      if (cusid_ele.length !== 0) {
        for (var i = 0; i < cusid_ele.length; ++i) {
          var item = cusid_ele[i];
          if (item.classList.contains("active") === true) {
            var Value = $(item).attr("data-target");
            selectRelationID =
              selectRelationID === 0
                ? (selectRelationID = Value)
                : (selectRelationID = selectRelationID + "," + Value);
          }
          if (i === cusid_ele.length - 1) {
            SendRequest = true;
          }
        }
      } else SendRequest = true;
      // if (selectRelationID === 0) {
      //   errorMessage = "همراهان خود را انتخاب نمایید.";
      //   this.props.toggleErrorMessage(errorMessage);
      //   this.props.toggleError();
      // } else {
      if (SendRequest === true) {
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("ID_Relation", selectRelationID);
        formdata.append("CalenderSelect", this.state.calenderSelect);
        formdata.append("CompetitionRequestTypeRef", 3);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-register`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                this.getRequest();
                errorMessage = "درخواست شما با موفقیت در سامانه ثبت شد.";
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
                this.toggleRegister();
              } else {
                errorMessage = myObject.message;
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
              }
            }
          })
          .catch((error) => console.log("error", error));
      }
      // }
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
  handleRequest = (e) => {
    this.declineRequest(e);
  };
  declineRequest = (e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      formdata.append("CompetitionRequestTypeRef", 3);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-competition-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getRequest();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("CompetitionRequestTypeRef", 3);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-competition-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { userCompetitionRequestJson: myObject.data },
                function() {
                  //console.log(this.state.userCompetitionRequestJson);
                }
              );
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  selectRelation = (id, e) => {
    if (id !== null) {
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var getValue = $(item).attr("data-target");
        if (getValue !== null && getValue.includes(id)) {
          item.classList.toggle("active");
        }
      }
    }
  };
  render() {
    const Relation_Active = this.props.userRelationsJson
      .filter(
        (item) =>
          item.Relation_Title !== "پدر" && item.Relation_Title !== "مادر"
      )
      .map((e) =>
        e.NeedEdit !== true ? (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvCandidate"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <div className="row">
                <div className="col-2 m-auto checkbox">
                  <label className="containerCustom">
                    <input
                      type="checkbox"
                      value={e.ID}
                      onClick={() => this.selectRelation(e.ID, this)}
                      name="Candidate"
                    ></input>
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="col-10 p-2">
                  <span className="bg-dark text-white wp-text-small rounded px-2 py-0">
                    جنسیت: {e.Sex}
                  </span>{" "}
                  <span className="bg-dark text-white wp-text-small rounded px-2 py-0 mr-2">
                    نسبت: {e.Relation_Title}
                  </span>
                  <div className="title mt-1">
                    کدملی: <b>{e.National_Code}</b>
                  </div>
                  <div className="title mt-1">
                    <strong>
                      {e.F_Name} {e.L_Name}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            key={e.ID}
            className="col-12 mb-2 bg-light dvRelation disable"
            data-target={e.ID}
          >
            <div className="w-100 rounded p-1">
              <span className="bg-dark text-white wp-text-small rounded px-2 py-0">
                جنسیت: {e.Sex}
              </span>{" "}
              <span className="bg-dark text-white wp-text-small rounded px-2 py-0 mr-2">
                نسبت: {e.Relation_Title}
              </span>
              <div className="title mt-1">
                <strong>
                  {e.F_Name} {e.L_Name}
                </strong>
              </div>
              <div className="describe">
                کدملی: <b>{e.National_Code}</b>
              </div>
              <span className="bg-danger text-white wp-text-small px-2">
                عدم امکان انتخاب به دلیل نقص در اطلاعات فرد
              </span>
            </div>
          </div>
        )
      );
    const myRelation = this.props.userRelationsJson
      .filter(
        (item) =>
          item.Relation_Title !== "پدر" && item.Relation_Title !== "مادر"
      )
      .map((e) => (
        <li key={e.ID} className={"Array-item readClass"}>
          <span className="bg-dark text-white wp-text-small rounded p-1">
            جنسیت: {e.Sex}
          </span>{" "}
          <span className="bg-dark text-white wp-text-small rounded p-1 mr-2">
            نسبت: {e.Relation_Title}
          </span>
          <div className="title mt-1">
            <strong>
              {e.F_Name} {e.L_Name}
            </strong>
          </div>
          <div className="describe inline">
            <span>
              کدملی: <b>{e.National_Code}</b>
            </span>
          </div>
          <div className="describe inline">
            <span>
              ش.شناسنامه: <b>{e.Identity_Code}</b>
            </span>
          </div>
          <div className="describe inline">
            <span>
              تاریخ تولد: <b>{e.DateOfBirthday}</b>
            </span>
          </div>
          <div className="describe inline">
            <span>
              محل صدور: <b>{e.Sodor_City}</b>
            </span>
          </div>
          <div className="text-left">
            <span className={e.State_CSS}>{e.State_Title}</span>
          </div>
          {e.NeedEdit === true ? (
            <React.Fragment>
              <span className="bg-danger text-white wp-text-small">
                اطلاعات این فرد ناقص است، لطفاً نسبت به تکمیل اطلاعات فرد اقدام
                نمایید.
              </span>
              <div className="text-left">
                <button
                  type="button"
                  onClick={() => this.props.getUserRelation(e.ID)}
                  className="btn btn-warning btn-sm rounded-0 py-0 px-1 small-font"
                >
                  ویرایش
                </button>
              </div>
            </React.Fragment>
          ) : null}
        </li>
      ));
    const myRequest = this.state.userCompetitionRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <li key={e.ID} className={"Array-item readClass"}>
          <span className="bg-dark text-white wp-text-small rounded p-1">
            تاریخ درخواست {e.RequestTime}
          </span>
          <div className="title my-2">
            <span className="text-dark">زمان حضور در مراسم: </span>{" "}
            <strong>{e.Comment}</strong>
          </div>
          <div className="describe bg-dark p-1 text-white">
            تعداد همراهان:{" "}
            <b className="text-white font-weight-bold">{e.Count - 1}</b>
            {"       "}
            مجموع نفرات:{" "}
            <b className="text-white font-weight-bold">{e.Count}</b>
          </div>
          <div className="describe mt-2">
            {e !== null &&
            e.data_addition !== null &&
            e.data_addition.length > 0 &&
            e.Count > 0
              ? e.data_addition.map((ee) => {
                  return (
                    <p className="mb-1">
                      <span className="badge bg-success p-2"> </span>{" "}
                      {ee.Relation_Title} - {ee.F_Name} {ee.L_Name} (کدملی{" "}
                      {ee.National_Code})
                    </p>
                  );
                })
              : null}
          </div>
          <div className="text-left">
            <span className={e.State_CSS}>{e.State_Title}</span>
          </div>
          {e.State === "1" ? (
            <div className="text-left">
              <button
                type="button"
                onClick={() => this.handleRequest(e.ID)}
                className="btn btn-danger btn-sm rounded-pill py-0 px-1 small-font"
              >
                انصراف
              </button>
            </div>
          ) : null}
        </li>
      </li>
    ));
    if (this.state.isRegister === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <div className="col-12 px-0 mt-2">
              <React.Fragment>
                <img
                  className="w-100"
                  src={CermonyBanner}
                  alt="جشن خانوادگی"
                ></img>
              </React.Fragment>
            </div>
            <p className="wp-header">درخواست‌های ثبت شده</p>
            <ul className="Array p-0 mb-5">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="font-weight-bold">
                    <p className="text-center mb-0">
                      هنوز درخواستی توسط شما در سیستم ثبت نشده است.
                    </p>
                    <p className="text-center">
                      جهت شرکت در جشن{" "}
                      <span
                        onClick={this.toggleRegister}
                        className="text-primary text-underline"
                      >
                        {" "}
                        ثبت نام{" "}
                      </span>{" "}
                      کنید
                    </p>
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            {myRequest.length === 0 ? (
              <button
                onClick={this.toggleRegister}
                className="btn btn-success wp-button-add"
              >
                <span>ثبت نام در جشن</span>
              </button>
            ) : (
              <button
                onClick={this.toggleEdit}
                className="btn btn-primary wp-button-add"
              >
                <span>ویرایش درخواست</span>
              </button>
            )}
          </div>
        </React.Fragment>
      );
    } else {
      if (this.state.stepNo === 1) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <p className="bg-primary wp-header text-white text-center my-1">
                جشن خانوادگی سالکو در شهرستان لامرد
              </p>
              <div className="row justify-content-center">
                <p className="text-center mb-0"></p>
                <div className="col-auto col-10 text-center">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={CermonyLamerd}
                    title="دورهمی خانوادگی"
                  >
                    <img
                      className="Delneshin"
                      src={CermonyLamerd}
                      alt="دورهمی خانوادگی"
                    ></img>
                  </a>
                </div>
                <div className="col-12 text-center mt-2">
                  <button
                    onClick={this.toggledecline}
                    className="btn btn-danger"
                  >
                    <span>انصراف</span>
                  </button>
                  <button
                    onClick={this.toggleSubmit}
                    className="btn btn-success mr-2"
                  >
                    <span>ادامه</span>
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 2) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <div className="alert alert-warning p-2 my-2">
                <i className="fa fa-info font-weight-bold"></i>
                <strong>پیغام!</strong>
                <p className="text-justify mb-0">
                  با توجه به قوانین ابلاغ شده، حضور در مراسم فقط برای همسر و
                  فرزندان پرسنل مجاز می‌باشد.
                </p>
                <p className="text-center font-weight-bold">
                  در صورتی که اطلاعات همسر و فرزندان شما ناقص است آن را تکمیل و
                  در مرحله بعد برای حضور در جشن انتخاب نمایید.
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-12">
                  {/* <div className="text-left mb-2">
                    <button
                      onClick={this.props.toggleRelation}
                      className="btn btn-sm btn-primary"
                    >
                      <span>+ افزودن</span>
                    </button>
                  </div> */}
                  <ul className="Array p-0 mb-2">
                    {myRelation.length === 0 ? (
                      <li className="Array-item">
                        <div className="title">
                          اطلاعات اعضای خانوار شما در سامانه ثبت نشده است.
                        </div>
                      </li>
                    ) : (
                      myRelation
                    )}
                  </ul>
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>مرحله بعد</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      } else if (this.state.stepNo === 3) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <Modal
                show={this.state.isSubmitForceRegister}
                onHide={this.toggleSubmitForceRegister}
              >
                <Modal.Header>
                  <Modal.Title>مجتمع صنایع آلومینیوم جنوب</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="w-100 text-justify text">
                    <p className="mb-0">{this.state.confirmMessage}</p>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="btn btn-sm dina-btn-orange"
                    onClick={this.toggleSubmitForceRegister}
                  >
                    انصراف
                  </Button>
                  <Button
                    className="btn btn-sm dina-btn-blue"
                    onClick={this.submitForm}
                  >
                    ثبت
                  </Button>
                </Modal.Footer>
              </Modal>
              <div className="w-100 mb-3"></div>
              <div className="col-12 bg-light dvBasePerson active">
                <div className="w-100 rounded p-1">
                  <span className="bg-dark text-white wp-text-small rounded p-1">
                    نسبت: نفر اصلی
                  </span>
                  <div className="title mt-1">
                    <strong>{this.props.userJson.full_name}</strong>
                  </div>
                  <div className="describe">
                    کدملی: <b>{this.props.userJson.national_id}</b>
                  </div>
                </div>
              </div>
              <div className="w-100 mb-3"></div>
              <p className="wp-header bg-primary my-1 text-white text-center">
                انتخاب روز مراسم
              </p>
              <div className="alert alert-danger p-1 m-0">
                <i className="fa fa-info"></i>
                <strong>پیغام!</strong>
                <p className="text-justify mb-0">
                  ظرفیت هر روز 1000 نفر می‌باشد، لطفاً روز مورد نظر خود را
                  انتخاب کنید.
                </p>
              </div>
              <div className="d-flex">
                <div
                  class="col-6 mt-2 bg-light dvCalender"
                  key="1"
                  onClick={() => this.selectCalender(1, this)}
                  data-target="1"
                >
                  <div class="w-100 rounded text-center p-1">
                    <div class="w-100 mb-2">
                      <strong>مجتمع گردشگری کیان</strong>
                    </div>
                    <div class="d-inline-grid mb-2">
                      <span class="bg-warning px-2 py-1 wp-text">
                        <span class="wp-text font-weight-bold" id="Calender_1">
                          پنجشنبه 6 آذرماه 1404
                        </span>
                      </span>
                      <span>ظرفیت 1000 نفر</span>
                    </div>
                    <div class="describe wp-text"></div>
                  </div>
                </div>
                <div
                  class="col-6 mt-2 bg-light dvCalender"
                  key="2"
                  onClick={() => this.selectCalender(2, this)}
                  data-target="2"
                >
                  <div class="w-100 rounded text-center p-1">
                    <div class="w-100 mb-2">
                      <strong>مجتمع گردشگری کیان</strong>
                    </div>
                    <div class="d-inline-grid mb-2">
                      <span class="bg-warning px-2 py-1 wp-text">
                        <span class="wp-text font-weight-bold" id="Calender_2">
                          جمعه 7 آذرماه 1404
                        </span>
                      </span>
                      <span>ظرفیت 1000 نفر</span>
                    </div>
                    <div class="describe wp-text"></div>
                  </div>
                </div>
              </div>
              <div className="w-100 mb-3"></div>
              <p className="wp-header bg-primary my-1 text-white text-center">
                انتخاب همراهان
              </p>
              <div className="alert alert-danger p-1 mt-1">
                <i className="fa fa-info"></i>
                <strong>پیغام!</strong>
                <p className="text-justify mb-0">
                  با توجه به قوانین امکان همراهی فقط برای همسر و فرزندان پرسنل
                  امکان پذیر می‌باشد.
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-12 mb-3">
                  <ul className="Array p-0 mb-2">
                    {Relation_Active.length === 0 ? (
                      <li className="Array-item">
                        <div className="title">
                          همراهی برای اضافه کردن به همراهان وجود ندارد.
                        </div>
                      </li>
                    ) : (
                      Relation_Active
                    )}
                  </ul>
                  <div className="text-left">
                    <button
                      onClick={this.toggledecline}
                      className="btn btn-sm btn-danger"
                    >
                      <span>بازگشت</span>
                    </button>
                    <button
                      onClick={this.toggleSubmit}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <span>ثبت نهایی درخواست</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    }
  }
}
export default Cermony;
